import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../environments';
import { buildParams } from '../../rooms';
import {
  CreateUpdateRole,
  Permission,
  Role,
  RoleQueryParams,
  RoleType,
  ServiceProviderType,
} from '../model/role.model';

@Injectable({
  providedIn: 'root',
})
export class RoleApiService {
  readonly #http = inject(HttpClient);
  readonly #roleConfigUrl =
    environment.shared.memberGroupsManagementApi + 'config';
  readonly #roleUrl = environment.shared.memberGroupsManagementApi + 'roles';

  public getAllPermissions(): Observable<Permission[]> {
    return this.#http.get<Permission[]>(`${this.#roleConfigUrl}/permissions`);
  }

  public getAllRoleTypes(): Observable<RoleType[]> {
    return this.#http.get<RoleType[]>(`${this.#roleConfigUrl}/roleTypes`);
  }

  public getAllServiceProviderTypes(): Observable<ServiceProviderType[]> {
    return this.#http.get<ServiceProviderType[]>(
      `${this.#roleConfigUrl}/serviceProviderTypes`
    );
  }

  public getAllRoles(queryParams: RoleQueryParams): Observable<Role[]> {
    const params = buildParams(queryParams);
    return this.#http.get<Role[]>(this.#roleUrl, { params });
  }
  public getRoleById(id: string): Observable<Role> {
    return this.#http.get<Role>(`${this.#roleUrl}/${id}`);
  }
  public createRole(role: CreateUpdateRole): Observable<Role> {
    return this.#http.post<Role>(this.#roleUrl, role);
  }

  public updateRole(roleId: string, role: CreateUpdateRole): Observable<Role> {
    return this.#http.put<Role>(`${this.#roleUrl}/${roleId}`, role);
  }

  public deleteRole(id: string): Observable<Role> {
    return this.#http.delete<Role>(`${this.#roleUrl}/${id}`);
  }
}
